import { NMP_PIECE_TYPE_CONFIG } from '../constants/nmpConstants';
/**
 * Registry: maps manipulative `type` → rightConfig key (or resolver function).
 * To add a new groupable type, add an entry here.
 */
export var GROUP_TYPE_RIGHT_CONFIG = {
    numberPiece: function (data) { return NMP_PIECE_TYPE_CONFIG[data.pieceType] || null; },
    moneyPiece: function (data) { return NMP_PIECE_TYPE_CONFIG[data.pieceType] || null; },
    patternShapes: 'patternShapes',
    coloredTiles: 'coloredTiles',
    fractionTiles: 'fractionTiles',
    linearPiece: 'linearPiece',
    // dice_pool has no rightConfig entry — omit from map
};
/**
 * Given group members, returns the rightConfig key if all members are "same type",
 * or null for mixed-type groups (right panel disabled).
 *
 * "Same type" means:
 * - Same outer `type` AND same resolved config key (e.g., all numberPiece with pieceType=numberYellow)
 * - OR all NMP (numberPiece + moneyPiece) with same pieceType
 */
export var getGroupRightConfigKey = function (members) {
    if (members.length === 0)
        return null;
    var firstType = members[0].type;
    var allSameType = members.every(function (m) { return m.type === firstType; });
    if (allSameType) {
        var config_1 = GROUP_TYPE_RIGHT_CONFIG[firstType];
        if (!config_1)
            return null; // type not in registry (e.g., dice_pool)
        if (typeof config_1 === 'function') {
            // Function resolver — check all members return same key
            var keys = new Set(members.map(function (m) { return config_1(m.data); }));
            return keys.size === 1 ? Array.from(keys)[0] : null;
        }
        return config_1; // static string
    }
    // Different outer types — check if all NMP (numberPiece + moneyPiece)
    var allNmp = members.every(function (m) { return m.type === 'numberPiece' || m.type === 'moneyPiece'; });
    if (allNmp) {
        var pieceTypes = new Set(members.map(function (m) { return m.data.pieceType; }));
        if (pieceTypes.size !== 1)
            return null;
        return NMP_PIECE_TYPE_CONFIG[Array.from(pieceTypes)[0]] || null;
    }
    // Mixed coloredTiles + linearPiece groups reuse the existing colored-tiles
    // right panel as long as at least one tile is in the group.
    var allCtOrLp = members.every(function (m) { return m.type === 'coloredTiles' || m.type === 'linearPiece'; });
    var hasTile = members.some(function (m) { return m.type === 'coloredTiles'; });
    if (allCtOrLp && hasTile)
        return 'coloredTiles';
    return null; // truly mixed types
};
